import CustomBodyRenderArquivo from '../childrens/customBodyRenderArquivo/.mixins';
import CustomBodyRenderAcoes from '../childrens/customBodyRenderAcoes/.mixins';

export default (props) => {
    return [
        'Título',
        'Descrição',
        {
            name: "URL",
            options: {
                filter: true,
                download: true,
                display:false
            },
        },
        {
            name: "Arquivo",
            options: {
                filter: false,
                download: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (CustomBodyRenderArquivo(props, value, tableMeta, updateValue));
                }
            }
        },
        {
            name: "Ações",
            options: {
                filter: false,
                download: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (CustomBodyRenderAcoes(props, value, tableMeta, updateValue));
                }
            }
        }
    ];
}